const toMissingAssociationFilter = operator => {
  return operator.value;
};
export default toMissingAssociationFilter;